var qeCli: any;

(function() {
    'use strict';

    /* Adds the required css for displaying qe-id annotations */
    var _addStyles = (): void => {
        $('html>head').append('<style qecli="true">' +
            '.qecliduplicate{background-color:indianred !important;border-top:indianred !important}' +
            '.qecli{position: absolute;z-index:9999;border-top:10px solid limegreen;border-right:10px solid transparent}' +
            '.qeclitag{position: absolute;z-index:9999;font-family:Arial;font-size:9px;background-color:limegreen;letter-spacing: 0px;' +
            'color:white;padding:1px;margin:0px;text-transform:none;line-height:10px;border-radius:3px;box-shadow:0px 0px 5px 5px white;white-space:nowrap;}' +
            '</style>');
    };

    /* Returns true if the element is an input (and can therefore not contain other elements) */
    var _isInput = (element: Element): boolean => {
        return $(element).is('input') || $(element).is('select') || $(element).is('textarea');
    };

    /* Adds the annotation of qe-id to the DOM */
    var _addAnnotation = (element: Element, anno: string): void => {
        if (_isInput(element)) {
            $(element).before(anno);
        } else {
            $(element).prepend(anno);
        }
    };

    /* Finds the required element and optioally executes the specified function upon it */
    var _getElement = <T>(qeid: string, run?: (element: Element) => T): T => {
        var e = _.reduce(qeid.split('>'), (e: JQuery, qeid: string) => e.find('[data-qe-id="' + qeid + '"]'), $(':root'));
        if (run && e && e.length === 1) {
            return run(e[0]);
        }
    };

    qeCli = {
        /* Verifies that supported elements have unique data-qe-id's */
        verify: (): any[] => {
            var items: any = [];
            $('[data-qe-id]').each((index: number, element: Element) => {
                var qeid = element.attributes.getNamedItem('data-qe-id').value;
                var existing = _.find(items, (item: any) => item.qeid === qeid);
                existing ? existing.count++ : items.push({ qeid: qeid, count: 1 });
            });
            var duplicates = _.compact(_.map(items, (item: any) => item.count > 1 ? item : undefined));
            var sizeKB: number = _.reduce(items, (sizeB: number, item: any) => { return sizeB + item.qeid.length + 14; }, 0);
            console.log(items.length - duplicates.length + ' elements have a unique data-qe-id ('+Math.floor((sizeKB/1024)*100)/100+' Kb)');
            _.each(duplicates, (item: any) => {
                console.error(item.count + ' elements have a data-qe-id of "' + item.qeid + '"');
            });
            return duplicates;
        },
        /* Shows small corner annotations for supported elements */
        show: (): void => {
            qeCli.hide();
            var duplicates = qeCli.verify();
            _addStyles();
            $('[data-qe-id]').each((index: number, element: Element) => {
                var qeid = element.attributes.getNamedItem('data-qe-id').value;
                var cssClass = _.where(duplicates, { 'qeid': qeid }).length > 0 ? 'qecli qecliduplicate' : 'qecli';
                _addAnnotation(element, '<div qecli="true" class="' + cssClass + '" title="' + qeid + '"></div>');
            });
        },
        /* Shows tags displaying the qe-id for supported elements */
        showTags: (): void => {
            qeCli.hide();
            var duplicates = qeCli.verify();
            _addStyles();
            $('[data-qe-id]').each((index: number, element: Element) => {
                var qeid: string = element.attributes.getNamedItem('data-qe-id').value;
                var cssClass = _.where(duplicates, { 'qeid': qeid }).length > 0 ? 'qeclitag qecliduplicate' : 'qeclitag';
                _addAnnotation(element, '<p qecli="true" class="' + cssClass + '" title="' + qeid + '">' + qeid + '</p>');
            });
        },
        /* Hides any annotations or tags for supported elements */
        hide: (): void => {
            $('[qecli="true"]').remove();
        },
        /* Gets the element */
        get: (qeid: string): HTMLElement => {
            return _getElement(qeid, (e: HTMLElement) => e);
        },
        /* Gets the text within the element */
        getText: (qeid: string): string => {
            return _getElement<string>(qeid, (e: HTMLElement) => e.textContent);
        },
        /* Performs a click on the element */
        click: (qeid: string): void => {
            _getElement(qeid, (e: HTMLElement) => { e.click(); });
        },
        /* Returns true if the element is visible */
        isVisible: (qeid: string): boolean => {
            return _getElement<boolean>(qeid, (e: HTMLElement) => !e.hidden && e.clientHeight !== 0 && e.clientWidth !== 0);
        },
        /* Sets focus to the element */
        focus: (qeid: string): void => {
            _getElement(qeid, (e: HTMLElement) => { e.focus(); });
        },
        /* Focuses and clicks on the combo to drop down the items */
        dropdownCombo: (qeid: string): void => {
            _getElement(qeid, (e: HTMLElement) => { $(e).find('.btn').first().click(); });
        }

    };

})();
